<script setup lang="ts">
import { useUserStore } from "@/domains/user/userStore";
import { useDashboardNavStore } from "@/stores/dashboardNavStore";
import { computed } from "vue";
import UserDetailsCard from "./UserDetailsCard.vue";

const userStore = useUserStore();
const dashboardNavStore = useDashboardNavStore();

const user = computed(() => userStore.getCurrentUser);

function onEdit() {
  dashboardNavStore.displayedContent = "account-edit";
}
</script>
<template>
  <UserDetailsCard :user="user" editable @edit="onEdit" />
</template>
